import AddUpdateProjectDetails from '../../../../components/organisms/add-update-project-card';
import { PROJECT_KEY_REGEX } from '../../../../constants/workspaces';
import useWorkspaceCreation from '../../../../context/WorkspaceCreationContext';

// regex to validate the project key
const regex = new RegExp(PROJECT_KEY_REGEX);

const WorkspaceProjectDetails = () => {
  const { projectName, projectKey, projectDescription, setProjectName, setProjectKey, setProjectDescription, errors, removeError } = useWorkspaceCreation();

  const handleProjectNameChange = (event) => {
    if (event.target.value) removeError('projectName');
    setProjectName(event.target.value);
  };

  const handleProjectKeyChange = (event) => {
    if (event.target.value && regex.test(event.target.value)) removeError('projectKey');
    setProjectKey(event.target.value);
  };

  const handleProjectDescriptionChange = (event) => {
    setProjectDescription(event.target.value);
  };

  return (
    <div className="workspace-creation-step-body">
      <h2 className="step-title">What&apos;s your first project?&nbsp;<span className="optional-text">(optional)</span></h2>
      <AddUpdateProjectDetails errors={errors} projectName={projectName} projectKey={projectKey} projectDescription={projectDescription} handleProjectDescriptionChange={handleProjectDescriptionChange} handleProjectKeyChange={handleProjectKeyChange} handleProjectNameChange={handleProjectNameChange} />
    </div>
  );
};

export default WorkspaceProjectDetails;
